// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCPX9LP6_xcd4FwiNpwv98x_GBzbSDIlW0",
  authDomain: "gmja-archive-bd479.firebaseapp.com",
  projectId: "gmja-archive-bd479",
  storageBucket: "gmja-archive-bd479.firebasestorage.app",
  messagingSenderId: "586706045064",
  appId: "1:586706045064:web:d7685b80e11d494d46373d",
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, app, db, storage };
